<template>
  <v-alert
    color="blue-grey"
    type="warning"
    prominent
    text
    icon="domain_add"
    class="py-6"
    :class="{ 'text-caption' : $vuetify.breakpoint.smAndDown }"
  >
    <v-row align="center">
      <div class="ml-3">
        <strong>
          2. osakeryhmä:
        </strong> {{ shareCount > 0
          ? `${additionalShares.add_share} - ${additionalShares.add_share2}` : '' }}
        <span v-if="shareCount < 1" class="red--text">Arvo puuttuu</span><br>
        <strong>
          Osakemäärä:
        </strong> {{ shareCount }} kpl<br>
        <strong>
          Huoneisto- tai muu tunnus:
        </strong> {{ additionalShares.residentialID }}
        <span v-if="!additionalShares.residentialID" class="red--text">Arvo puuttuu</span><br>
        <strong>
          Pinta-ala:
        </strong> {{ area }} m&sup2;<br>
        <strong>
          Kohteen tyyppi:
        </strong> {{ assetTypes[additionalShares.assetType] }}<br>
        <strong>
          Luovutuksen tyyppi:
        </strong> {{ transferTypes[additionalShares.transferType] }}<br>
        <strong>
          2. osakeryhmän arvo velattomasta kauppahinnasta:
        </strong> {{ additionalShares.shareSellingPrice | currency }}<br>
        <strong>
          2. osakeryhmään kohdistuva yhtiölainaosuus:
        </strong> {{ additionalShares.buyerShareLoan | currency }}<br>
        <span
          v-if="!(additionalShares.buyerShareLoan > 0)
            && !(additionalShares.shareSellingPrice > 0)"
          class="red--text"
        >
          Määritä osuus velattomasta kauppahinnasta tai yhtiölainaosuudesta
        </span><br>
        <strong>
          Varainsiirtoverovapaus soveltuu:
        </strong> {{ additionalShares.firstTimeBuyer ? 'Kyllä' : 'Ei' }}<br>
      </div>
      <v-spacer/>
      <v-btn
        :class="{ 'mt-4' : $vuetify.breakpoint.smAndDown }"
        class="mx-4"
        text
        :fab="mobile"
        color="primary"
        @click="modifyAdditionalSharesDialog = true"
      >
        <template v-if="!mobile">
          Muokkaa
        </template>
        <v-icon v-if="mobile" dark>
          edit
        </v-icon>
      </v-btn>
    </v-row>
    <v-dialog
      v-model="modifyAdditionalSharesDialog"
      persistent
      max-width="400"
    >
      <modify-additional-shares
        :additional-shares="additionalShares"
        :asset-types="assetTypesMapped"
        :transfer-types="transferTypesMapped"
      />
    </v-dialog>
  </v-alert>
</template>
<script>
export default {
  name: 'AdditionalShares',
  components: {
    'modify-additional-shares': () => import('@/components/taxTransfer/ModifyAdditionalShares'),
  },
  props: {
    additionalShares: {
      type: Object,
      default: () => {},
    },
    assetTypes: {
      type: Object,
      default: () => {},
    },
    transferTypes: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    modifyAdditionalSharesDialog: false,
  }),
  computed: {
    assetTypesMapped() {
      const keys = Object.keys(this.assetTypes);
      return keys.map(a => ({ text: this.assetTypes[a], value: a }));
    },
    transferTypesMapped() {
      const keys = Object.keys(this.transferTypes);
      return keys.map(a => ({ text: this.transferTypes[a], value: a }));
    },
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    area() {
      if (!this.additionalShares.area) return 0;
      return this.additionalShares.area.replace('.', ',');
    },
    shareCount() {
      if (this.additionalShares.add_share2 > 0 && this.additionalShares.add_share > 0) {
        return (parseInt(this.additionalShares.add_share2, 10)
          - parseInt(this.additionalShares.add_share, 10) + 1);
      }
      return 0;
    },
  },
  created() {
    this.$bus.$on('closeAdditionalShareDialog', () => {
      this.modifyAdditionalSharesDialog = false;
    });
  },
};
</script>
